export const populationDataHead = {
  country: {
    en: "country",
		ko: "국가",
		zh: "国家",
  },
  population: {
		en: "population",
		ko: "인구",
		zh: "人口",
	},
}